<div class='finance-awards-tab-2-part'>
	This is the finance-awards tab 2
</div>